<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
    >
        <v-card
            v-if="attachment_confirmation_settings != null"
        >
            <v-card-title>Attachment Confirmation</v-card-title>
            <v-card-text>
                <m-edit-text
                    label="Confirmation Title"
                    v-model="attachment_confirmation_settings.confirmation_title"
                />

                <m-edit-textarea
                    label="Confirmation Message"
                    v-model="attachment_confirmation_settings.confirmation_message"
                />

                <v-layout row wrap>
                    <v-flex
                        class="pl-3"
                        flex-grow-0>
                        <v-switch
                            label="External Attachments"
                            v-model="attachment_confirmation_settings.confirm_before_sending_externally"
                        >
                            <v-icon
                                slot="append"
                                style="pointer-events: auto;"
                                v-on:click="showExternalAttachmentHelpText()"
                            >
                                mdi-information-outline
                            </v-icon>
                        </v-switch>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex
                        class="pl-3"
                        flex-grow-0>
                        <v-switch
                        label="Internal Attachments"
                        v-model="attachment_confirmation_settings.confirm_before_sending_internally"
                        >
                            <v-icon
                                slot="append"
                                style="pointer-events: auto;"
                                v-on:click="showInternalAttachmentHelpText()"
                            >
                                mdi-information-outline
                            </v-icon>
                        </v-switch>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex
                        class="pl-3"
                        flex-grow-0>
                        <v-switch
                            label="Require Response? "
                            v-model="require_response"
                        >
                            <v-icon
                                class="pr-3"
                                slot="append"
                                style="pointer-events: auto;"
                                v-on:click="showRequireResponseHelpText()"
                            >
                                mdi-information-outline
                            </v-icon>
                        </v-switch>
                    </v-flex>
                    <v-flex
                        class="pr-3"
                        flex-grow-1
                        v-if="require_response"
                    >
                        <m-edit-text
                            label="Required Response"
                            v-model="attachment_confirmation_settings.required_response"
                        />
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="gray darken-1"
                    text
                    @click="dialog = false"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {
    data() {
        return {
            dialog: false,
            require_response: false,
            attachment_confirmation_settings: null,
            organization_id: null,
            on_success: null,
        }
    },

    methods: {
        showRequireResponseHelpText()
        {
            this.$rc.alert('If this is selected, the user will be required to type out ' +
                'the provided response before proceeding.');
        },
        showExternalAttachmentHelpText()
        {
            this.$rc.alert('If this is selected, the settings above will apply when ' +
                'sending attachments by text message to customers');
        },
        showInternalAttachmentHelpText()
        {
            this.$rc.alert('If this is selected, the settings above will apply when ' +
                'sending attachments to other RedChirp RedChirp Users within the RedChirp software.');
        },
        showDialog(org_id, attachment_confirmation_settings, on_success) {
            this.organization_id = org_id;
            this.dialog = true;
            this.on_success = on_success;

            this.attachment_confirmation_settings = attachment_confirmation_settings;
            this.require_response = attachment_confirmation_settings.required_response != null
                && attachment_confirmation_settings.required_response.length > 0;
        },

        onOk() {
            this.dialog = false;

            // if required response is set to false, wipe the field before going to backend
            if (!this.require_response)
            {
                this.attachment_confirmation_settings.required_response = null;
            }
            else
            {
                if (this.attachment_confirmation_settings.required_response == null
                    || this.attachment_confirmation_settings.required_response.length == 0)
                {
                    this.attachment_confirmation_settings.required_response = "No PHI";
                }
            }

            let patch = {
                'organization_id' : this.organization_id,
                'attachment_confirmation_settings' : this.attachment_confirmation_settings,
            };

            this.$rc.showSpinner();

            this.$rc.patchOrganizationFeatures(
                patch,

                (data) => {
                    this.$rc.hideSpinner();
                    if (this.on_success) this.on_success(data);
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        }
    },
}
</script>

<style lang="scss" scoped>

</style>